<template>
	<a
		href="javascript:void(0)"
		class="blue-link d-flex align-items-center"
		data-toggle="tab"
		:aria-controls="tabId"
		@click="onActionClick"
	>
		<i v-if="tabIcon" :class="['fa', tabIcon, 'mr-1']"></i>
		{{ actionLabel }}
	</a>
</template>

<script>
export default {
	props: {
		tabId: {
			type: String,
			required: true, // Ensure tabId is provided
		},
		action: {
			type: Function,
			default: null, // Default to null if no action is provided
		},
		actionLabel: {
			type: String,
			default: 'Action', // Default action label
		},
		href: {
			type: String,
			default: null, // Default to null if no href is provided
		},
		tabIcon: {
			type: String,
			default: null, // Default to null if no icon is provided
		},
	},
	methods: {
		onActionClick() {
			// Perform the action if it exists
			if (this.action) {
				this.action();
			}

			if (this.href) {
				window.history.pushState({}, '', this.href);
			}

			$('a[data-toggle="tab"]').removeClass('active');
			$(`a[data-toggle="tab"][aria-controls="${this.tabId}"]`).addClass('active');
			$(this.$el).removeClass('active');
		},
	},
};
</script>
